module.exports = __webpack_public_path__ + "img/20.86267ea8.jpg";